
import { Button } from "@/components/ui/button";
import { Save, X } from "lucide-react";

interface EpisodeFormActionsProps {
  onCancel: () => void;
  isLoading: boolean;
}

export const EpisodeFormActions = ({ onCancel, isLoading }: EpisodeFormActionsProps) => {
  return (
    <div className="flex justify-end space-x-2">
      <Button type="button" variant="outline" onClick={onCancel} disabled={isLoading}>
        <X className="h-4 w-4 mr-2" />
        Cancel
      </Button>
      <Button type="submit" disabled={isLoading}>
        <Save className="h-4 w-4 mr-2" />
        {isLoading ? "Saving..." : "Save"}
      </Button>
    </div>
  );
};
